import { render } from "./BankId.vue?vue&type=template&id=4ab1170f&scoped=true"
import script from "./BankId.vue?vue&type=script&lang=js"
export * from "./BankId.vue?vue&type=script&lang=js"

import "./BankId.vue?vue&type=style&index=0&id=4ab1170f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab1170f"]])

export default __exports__